/** @format */

import template from './gb-add-text-widget.html';

export const GbAddTextWidgetComponent = {
    template,
    require: {
        gbPresenter: '^^',
    },
    bindings: {
        widget: '=',
    },
    controller: class GbAddTextWidgetComponent {
        constructor($gbTextProjectorWidget, $translate) {
            'ngInject';

            this.$gbTextProjectorWidget = $gbTextProjectorWidget;
            this.$translate = $translate;
        }

        getWidget() {
            return this.widget;
        }

        addTextWidget() {
            let widget = new this.$gbTextProjectorWidget({
                text: this.$translate.instant('TEXT_WIDGET_EXAMPLE_TEXT'),
                x: 50,
                y: 50,
                x_unit: '%',
                y_unit: '%',
                width: null,
                width_unit: '%',
                height: null,
                height_unit: '%',
                opacity: 1,
                font_size: 30,
            });

            this.gbPresenter.tempWidgets.push(widget);
        }
    },
};
